'use strict';

module.exports = require('./dom-scroll-into-view');


//////////////////
// WEBPACK FOOTER
// ./~/dom-scroll-into-view/lib/index.js
// module id = ./node_modules/dom-scroll-into-view/lib/index.js
// module chunks = portal incabStudent incabManager incabTeacher incabHelpdesk marathons